import { create } from 'zustand';

const STORAGE_KEY = 'vvsrs.auth';

const initial = (() => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
})();

export const useAuthStore = create((set) => ({
  token: initial?.token ?? null,
  expiresAt: initial?.expiresAt ?? null,
  usuario: initial?.usuario ?? null,

  setAuth: (token, expiresAt, usuario) => {
    const data = { token, expiresAt, usuario };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    set({ token, expiresAt, usuario });
  },

  logout: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ token: null, expiresAt: null, usuario: null });
  },

  isAuthenticated: () => !!initial?.token,
}));
